import { supabase } from '../../config/supabase';

/**
 * Send SMS via Twilio
 * @param {string} to - Phone number (with country code, e.g., +61412345678)
 * @param {string} message - SMS message content
 * @param {string} companyId - Company ID (required)
 * @param {string} userId - Optional user ID for logging
 * @param {string} jobId - Optional job ID for logging
 * @returns {Promise<Object>} Result of SMS send
 */
export const sendSMS = async (to, message, companyId, userId = null, jobId = null) => {
    try {
        if (!companyId) {
            throw new Error('Company ID is required');
        }

        const { data, error } = await supabase.functions.invoke('send-sms', {
            body: {
                to,
                message,
                companyId,
                userId,
                jobId
            }
        });

        if (error) throw error;

        return { data, error: null };
    } catch (error) {
        console.error('Error sending SMS:', error);
        return { data: null, error };
    }
};

/**
 * Send job assignment notification
 */
// export const sendJobAssignmentSMS = async (phoneNumber, userName, jobId, jobType, companyId) => {
//     const message = `Hi ${userName}, you've been assigned to job ${jobId} (${jobType}). Please check your dashboard for details.`;
//     return await sendSMS(phoneNumber, message, companyId, null, jobId);
// };

/**
 * Send delivery notification
 */
export const sendInTransitNotificationSMS = async (phoneNumber, customerName, shortId, jobId, deliveryDate, company) => {

    if (!phoneNumber || phoneNumber?.length <= 0) return;

    const message = `Hi ${customerName}, your delivery for job ${jobId} is on its way. ETA: ${deliveryDate}. Tracking code: ${shortId}. Track: https://${process.env.REACT_APP_APP_URL}/track/${shortId} – ${company.name}`;
    return await sendSMS(phoneNumber, message, company.id, null, jobId);
};

export const sendDeliveredNotificationSMS = async (phoneNumber, customerName, shortId, jobId, deliveryDate, company) => {

    if (!phoneNumber || phoneNumber?.length <= 0) return;

    const message = `Hi ${customerName}, your delivery for job ${jobId} has been delivered. Delivered on: ${deliveryDate}. Tracking code: ${shortId}. Details: https://${process.env.REACT_APP_APP_URL}/track/${shortId} – ${company.name}`;
    return await sendSMS(phoneNumber, message, company.id, null, jobId);
};

/**
 * Send urgent job notification
 */
// export const sendUrgentJobSMS = async (phoneNumber, userName, jobId, companyId) => {
//     const message = `URGENT: ${userName}, job ${jobId} requires immediate attention. Please check the system ASAP.`;
//     return await sendSMS(phoneNumber, message, companyId, null, jobId);
// };

/**
 * Get SMS logs for a company
 * @param {string} companyId - Company ID
 * @param {number} limit - Number of logs to retrieve
 * @returns {Promise<Object>} SMS logs
 */
export const getSMSLogs = async (companyId, limit = 50) => {
    try {
        const { data, error } = await supabase
            .from('sms_logs')
            .select('*')
            .eq('company_id', companyId)
            .order('sent_at', { ascending: false })
            .limit(limit);

        if (error) throw error;

        return { data, error: null };
    } catch (error) {
        console.error('Error fetching SMS logs:', error);
        return { data: null, error };
    }
};